import React, {Component} from "react";

import { getUnreadNotifications} from "../../../modules/notification.js";

require("./notification-menu.css");
export default class NotificationMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            notifications: []
        };
    }

    async componentDidMount() {
        let {token} = this.props;
        let unreadNotificationsResponse = await getUnreadNotifications(token);

        let unreadNotifications = unreadNotificationsResponse.data;

        if (unreadNotifications) {
            let notifications = unreadNotifications.unread_notifications

            this.setState({
                notifications: notifications,
                show_dropdown: false
            });
        }
    }
    
    printNotifications() {
        let {notifications} = this.state;

        if (notifications.length > 0) {
            return notifications.map((notification) => {

                let date = new Date(notification.date);

                let formattedDate = date.getMonth() + 1 +'/'+ date.getDate() + '/' +date.getFullYear();
                return <div className='notification'><span className='notification_message'>{notification.message}</span><span className='notification_date'>{formattedDate}</span></div>
            });
        }   
        else {
            return (
            <div>
                No new notifications
            </div>
            )
        }
        
    }

    render() {

        let {show_notifications_menu, show_func, hide_func} = this.props;

        return (
            <div id='notifications_menu'>
                <div onClick={show_func}><i className='fa fa-bell'></i></div>

                {show_notifications_menu && 
                    <div onMouseLeave={hide_func} id='notifications_dropdown_menu'>
                        {this.printNotifications()}
                    </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/containers/gamification-menu/notification-menu.js